.AccountDeletionScreen {
  flex-grow: 1;
}

.avatar {
  --local-avatar-size: 55px;
  --local-avatar-font-size: 37px;
  position: relative;
  user-select: none;
  display: inline-block;
  font-weight: normal;
  height: var(--local-avatar-size);
  width: var(--local-avatar-size);
  margin: 0 0;
}
.avatar div.content,
.avatar img.content {
  height: var(--local-avatar-size);
  width: var(--local-avatar-size);
  border-radius: 10%;
  pointer-events: none;
}
.avatar div.content {
  background-color: #505050;
  line-height: var(--local-avatar-size);
  object-fit: cover;
  color: var(--avatarLabelColor);
  text-align: center;
  font-size: var(--local-avatar-font-size);
}
.avatar img.content {
  object-fit: cover;
}

.accountCard {
  display: flex;
  background: var(--bp4DialogBgSecondary);
  border-radius: 4px;
  padding: 8px;
  margin: 8px;
}

.accountName {
  display: flex;
  flex-direction: column;
  margin-inline-start: 8px;
  justify-content: center;
  min-width: 0;
  word-wrap: break-word;
}

.accountSize {
  font-size: smaller;
  color: var(--textSecondary);
}